import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import ShitCoin from "../../assets/images/shitcoin-logo.png";
import Arrow from "../../assets/images/arrow-icon.svg";
import { Link, useNavigate } from "react-router-dom";
import "./ShitcoinChain.css";
function Banner() {
  const navigate = useNavigate();

  return (
    <div className="banner wallet-banner">
      <Container fluid className="custom-container">
        <Row className="align-items-center">
          <Col lg={5}>
            <div className="shit-coin-logo">
              <Image src={ShitCoin} fluid />
            </div>
          </Col>
          <Col lg={1}></Col>

          <Col lg={6}>
            <div className="content-wrapper">
              <h1>CHOOSE BLOCKCHAIN</h1>
              <ul className="wallet-list mb-0">
                <li>
                  <Link
                    to="/rewards"
                    className="text-white text-decoration-none"
                  >
                    Ethereum
                  </Link>
                </li>
                <li>
                  <Link
                    to="/rewards"
                    className="text-white text-decoration-none"
                  >
                    Binance SmartChain
                  </Link>
                </li>
                <li>
                  <Link
                    to="/rewards"
                    className="text-white text-decoration-none"
                  >
                    Tron
                  </Link>
                </li>
                <li>
                  <Link
                    to="/rewards"
                    className="text-white text-decoration-none"
                  >
                    Polygon
                  </Link>
                </li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
      <button
        className="back-btn bg-transparent border-0 d-flex align-items-center"
        onClick={() => navigate(-1)}
      >
        <Image className="me-1" src={Arrow} fluid />
        Back
      </button>
    </div>
  );
}
export default Banner;
